// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"f575199c","518":"266fb054"}[chunkId] + ".chunk.js";
};